/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    blockquote: "blockquote",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Styling any component"
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "styled"
      }), " method works perfectly on all of your own or any third-party component, as long as they attach the passed ", _jsx(_components.code, {
        children: "className"
      }), " prop to a DOM element."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["If you are using ", _jsx(_components.code, {
          children: "react-native"
        }), " keep in mind to use ", _jsx(_components.code, {
          children: "style"
        }), " instead of ", _jsx(_components.code, {
          children: "className"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// This could be react-router-dom's Link for example\nconst Link = ({ className, children }) => (\n  <a className={className}>\n    {children}\n  </a>\n);\n\nconst StyledLink = styled(Link)`\n  color: #BF4F74;\n  font-weight: bold;\n`;\n\nrender(\n  <div>\n    <Link>Unstyled, boring Link</Link>\n    <br />\n    <StyledLink>Styled, exciting Link</StyledLink>\n  </div>\n);\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["You can also pass tag names into the ", _jsx(_components.code, {
          children: "styled()"
        }), " factory call, like so: ", _jsx(_components.code, {
          children: "styled(\"div\")"
        }), ". In fact, the ", _jsx(_components.code, {
          children: "styled.tagname"
        }), " helpers are just aliases that do the same."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
